import _ from 'lodash';

const THEME_TYPES = {branded: 0, grayscale: 1, grayedout: 2};
const RADIUS_TYPES = {circle: 0, no_radius: 1};
const THEME_PROPS = [
    {name: 'type', type: THEME_TYPES},
    {name: 'borderRadius', type: RADIUS_TYPES},
    {name: 'inverse', type: 'boolean'},
    {name: 'hasBackground', type: 'boolean'},
    {name: 'hasBorder', type: 'boolean'},
    {name: 'backgroundColor', type: 'number'},
    {name: 'iconColor', type: 'number'},
    {name: 'borderColor', type: 'number'}
];

export default function themeDecoder(themeId = -1) {
    let theme = {};

    for (let i = 0; i < THEME_PROPS.length && themeId > 0; i++) {
        let prop = THEME_PROPS[i];
        let value = themeId % 10;

        if (prop.type === 'boolean') {
            theme[prop.name] = !!value;
        } else if (typeof prop.type === 'object') {
            theme[prop.name] = _.invert(prop.type)[value];
        } else {
            theme[prop.name] = value;
        }

        themeId = Math.floor(themeId / 10);
    }

    return theme;
}



// WEBPACK FOOTER //
// ./services/ThemeDecoder.js